module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( source || 'MANUAL' ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( town ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( state ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( zip ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( address ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( usage ))==null?'':__t)+
'</td>\r\n';
 if (canEdit) { 
__p+='\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'"><span class="glyphicon glyphicon-edit clickable" id="address-edit" rel-id="'+
((__t=( uuid ))==null?'':__t)+
'"/></td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'"><span class="glyphicon glyphicon-remove clickable" id="address-delete" rel-id="'+
((__t=( uuid ))==null?'':__t)+
'"/></td>\r\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/address-row.html
// module id = 257
// module chunks = 0